export default __webpack_public_path__ + "static/media/17-100.4c5795a9.jpg";